import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { CREATIVE_DETAILS_ACTIONS, CREATIVE_TAXONOMY_ACTIONS } from "./actions/Creatives";

export function loadCreative(creativeId){
	return (dispatch, getState) => {
		if (!creativeId) {
			return Promise.reject({
				success: false,
				message: "Can't fetch creative.  Invalid ID.",
			});
		}

		return dispatch({
			type: CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				version: 2,
				url: `ui/creatives/${creativeId}`,
				success: CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_SUCCESS,
				error: CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_ERROR,
			},
		});
	};
}

export function loadCreativeVariables(libraryId, creativeId){
	return (dispatch) => {
		return dispatch({
			type: CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_VARIABLES_AJAX,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives/${creativeId}/variables`,
				method: "get",
				success: CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_VARIABLES_SUCCESS,
				error: CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_VARIABLES_ERROR,
			},
			meta: SUPPRESS_SUCCESS_GROWL,
		});
	};
}

export function clearDetails(){
	return(dispatch, getstate)=>{
		return dispatch({
			type:CREATIVE_DETAILS_ACTIONS.CLEAR_CREATIVE_DETAILS,
		});
	};
}

export function createLibrary(data){
	return (dispatch, getState) => {
		return dispatch({
			type: CREATIVE_DETAILS_ACTIONS.CREATE_LIBRARY_AJAX,
			AJAX: {
				url: "creative-libraries",
				method: "post",
				data: {
					creativeLibrary: data,
				},
				success: CREATIVE_DETAILS_ACTIONS.CREATE_LIBRARY_SUCCESS,
				error: CREATIVE_DETAILS_ACTIONS.CREATE_LIBRARY_ERROR,
			},
		});
	};
}

export function updateCreative(libraryId, creativeId, data){
	return (dispatch) => {
		return dispatch({
			type: CREATIVE_DETAILS_ACTIONS.UPDATE_CREATIVE_AJAX,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives/${creativeId}`,
				method: "put",
				data,
				success: CREATIVE_DETAILS_ACTIONS.UPDATE_CREATIVE_SUCCESS,
				error: CREATIVE_DETAILS_ACTIONS.UPDATE_CREATIVE_ERROR,
			},
			meta:{ suppressGrowl:false },
		});
	};
}

export function saveSocial2Creative(data) {
	return (dispatch, getState) => {
		const { id } = getState().creativeDetails || {};

		return dispatch({
			type: CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL2_CREATIVE_AJAX,
			AJAX:{
				version: 2,
				url: `ui/creatives/${id}`,
				method: "put",
				data,
				success: CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL2_CREATIVE_SUCCESS,
				error: CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL2_CREATIVE_ERROR,
			},
		});
	};
}

export function createNative(libraryId, creativeName, variables) {
	return ((dispatch) => {
		return dispatch({
			type: CREATIVE_DETAILS_ACTIONS.NATIVE_CREATIVE_AJAX,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/creatives/create-native-ad`,
				method: 'post',
				data: { campaignId: libraryId, name: creativeName, variables },
				success: CREATIVE_DETAILS_ACTIONS.NATIVE_CREATIVE_SUCCESS,
				error: CREATIVE_DETAILS_ACTIONS.NATIVE_CREATIVE_ERROR,
			},
		});
	});
}

const actionCreators = {
	loadCreative,
	clearDetails,
	createLibrary,
	updateCreative,
};

const initialCreativeDetails = {
	success: true,
	isLoaded: false,
	isSaving: false,
	hasErrorLoading: false,
};

const handlers = {
	[CREATIVE_DETAILS_ACTIONS.CLEAR_CREATIVE_DETAILS]: clearCreativeDetails,

	[CREATIVE_DETAILS_ACTIONS.CREATE_LIBRARY_AJAX]: isLoadingCreative,
	[CREATIVE_DETAILS_ACTIONS.CREATE_LIBRARY_SUCCESS]: initCreative,
	[CREATIVE_DETAILS_ACTIONS.CREATE_LIBRARY_ERROR]: initCreativeError,

	[CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_AJAX]: isLoadingCreative,
	[CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_SUCCESS]: initCreative,
	[CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_ERROR]: initCreativeError,

	[CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_VARIABLES_AJAX]: isLoadingCreativeVariables,
	[CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_VARIABLES_SUCCESS]: initCreativeVariables,
	[CREATIVE_DETAILS_ACTIONS.LOAD_CREATIVE_VARIABLES_ERROR]: initCreativeVariablesError,

	[CREATIVE_DETAILS_ACTIONS.UPDATE_CREATIVE_AJAX]: isUpdatingCreative,
	[CREATIVE_DETAILS_ACTIONS.UPDATE_CREATIVE_SUCCESS]: initCreative,
	[CREATIVE_DETAILS_ACTIONS.UPDATE_CREATIVE_ERROR]: initCreativeError,

	[CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL_CREATIVE_AJAX]:    isUpdatingCreative,
	[CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL_CREATIVE_SUCCESS]: initCreative,
	[CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL_CREATIVE_ERROR]:   initCreativeError,

	[CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL2_CREATIVE_AJAX]:    isUpdatingCreative,
	[CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL2_CREATIVE_SUCCESS]: initCreative,
	[CREATIVE_DETAILS_ACTIONS.UPDATE_SOCIAL2_CREATIVE_ERROR]:   initCreativeError,

	[CREATIVE_DETAILS_ACTIONS.NATIVE_CREATIVE_AJAX]: isUpdatingCreative,
	[CREATIVE_DETAILS_ACTIONS.NATIVE_CREATIVE_SUCCESS]: initCreative,
	[CREATIVE_DETAILS_ACTIONS.NATIVE_CREATIVE_ERROR]: initCreativeError,

	[CREATIVE_TAXONOMY_ACTIONS.CLASSIFY_CREATIVES_SUCCESS]: updateCreativeClassifySuccess,
};

function clearCreativeDetails(state, action){
	return { ...initialCreativeDetails };
}

function isLoadingCreative(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

function isUpdatingCreative(state, action){
	return {
		...state,
		isSaving: true,
	};
}

function initCreative(state, action){
	let { data } = action.payload;

	return {
		...state,
		...data,
		isLoaded: true,
		isSaving: false,
		hasErrorLoading: false,
	};
}

function initCreativeError(state, action){
	return {
		...state,
		isLoaded: true,
		isSaving: false,
		hasErrorLoading: true,
	};
}

function isLoadingCreativeVariables(state, action){
	return {
		...state,
		isVariablesLoaded: false,
		hasErrorLoadingVariables: false,
	};
}

function initCreativeVariables(state, action){
	const { variables = []} = action.payload?.data || {};
	return {
		...state,
		isVariablesLoaded: true,
		hasErrorLoadingVariables: false,

		variables,
	};
}

function initCreativeVariablesError(state, action){
	return {
		...state,
		isVariablesLoaded: true,
		hasErrorLoadingVariables: true,
	};
}

function updateCreativeClassifySuccess(state, action) {
	const creatives = action.AJAX?.data?.creatives || [];

	if (creatives.length === 1 && creatives[0]?.id === state.id) {
		return {
			...state,
			autoClassificationStatus: "In progress",
		};
	}

	return state;
}

export default createReducer(initialCreativeDetails, handlers);
export const CreativeDetails = actionCreators;
